(() => {
  const menu = document.querySelector('[data-klaim-mobile-menu-lab]');
  if (!menu) return;

  const triggers = document.querySelectorAll('[data-klaim-mobile-menu-lab-trigger]');
  const closeButton = menu.querySelector('[data-klaim-mobile-menu-close]');
  const searchButton = menu.querySelector('[data-klaim-mobile-menu-search]');
  const countryButton = menu.querySelector('[data-klaim-mobile-menu-country]');
  const languageButton = menu.querySelector('[data-klaim-mobile-menu-language]');
  const tabs = [...menu.querySelectorAll('[data-klaim-mobile-menu-tab]')];
  const panels = [...menu.querySelectorAll('[data-klaim-mobile-menu-panel]')];
  const progress = menu.querySelector('[data-klaim-mobile-menu-progress]') || menu.querySelector('.klaim-mobile-menu-lab__rule');
  const announcementHost = menu.querySelector('[data-klaim-mobile-menu-announcement]');
  let lastFocused = null;
  let lockedScrollY = 0;
  let closeTimer;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const headerPanels = window.KlaimHeaderPanels;
  menu.inert = menu.getAttribute('aria-hidden') !== 'false';

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const currentTabName = () => {
    const activeTab = tabs.find((tab) => tab.classList.contains('is-active'));
    return activeTab?.dataset.klaimMobileMenuTab || tabs[0]?.dataset.klaimMobileMenuTab || 'shop';
  };

  const setTab = (name) => {
    progress?.setAttribute('data-active-tab', name);
    tabs.forEach((tab) => {
      const active = tab.dataset.klaimMobileMenuTab === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });
    panels.forEach((panel) => {
      const active = panel.dataset.klaimMobileMenuPanel === name;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  };

  const syncAnnouncement = () => {
    if (!announcementHost) return;
    const source = document.querySelector('#HdrAnnouncementBar');
    announcementHost.replaceChildren();
    if (!source) {
      announcementHost.hidden = true;
      return;
    }
    const clone = source.cloneNode(true);
    clone.removeAttribute('id');
    clone.removeAttribute('style');
    announcementHost.appendChild(clone);
    announcementHost.hidden = false;
  };

  const open = (event) => {
    if (!isMobile()) return;
    event?.preventDefault();
    event?.stopPropagation();
    event?.stopImmediatePropagation();
    if (menu.getAttribute('aria-hidden') === 'false') { close(event); return; }
    window.clearTimeout(closeTimer);
    lastFocused = document.activeElement;
    lockedScrollY = window.scrollY;
    headerPanels?.activate('menu', event?.currentTarget);
    document.documentElement.classList.add('klaim-mobile-menu-lab-open');
    document.body.classList.add('klaim-mobile-menu-lab-open');
    if (!headerPanels) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.width = '100%';
      syncAnnouncement();
    }
    menu.hidden = false;
    // Commit the closed position after display:none before starting the transition.
    menu.getBoundingClientRect();
    menu.inert = false;
    menu.setAttribute('aria-hidden', 'false');
    triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));
    setTab(currentTabName());
    window.requestAnimationFrame(() => {
      if (menu.getAttribute('aria-hidden') === 'false') (headerPanels ? menu.querySelector('[data-klaim-mobile-menu-tab].is-active') : closeButton)?.focus({ preventScroll: true });
    });
  };

  const close = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    if (menu.getAttribute('aria-hidden') !== 'false') return;
    menu.inert = true;
    menu.setAttribute('aria-hidden', 'true');
    triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    document.documentElement.classList.remove('klaim-mobile-menu-lab-open');
    document.body.classList.remove('klaim-mobile-menu-lab-open');
    if (!headerPanels) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
    }
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      if (menu.getAttribute('aria-hidden') === 'true') menu.hidden = true;
    }, reducedMotion.matches ? 0 : 280);
    if (headerPanels) headerPanels.deactivate('menu');
    else if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
  };

  headerPanels?.register('menu', { element: menu, close });

  triggers.forEach((trigger) => trigger.addEventListener('click', open, true));
  closeButton?.addEventListener('click', close);
  tabs.forEach((tab) => tab.addEventListener('click', () => setTab(tab.dataset.klaimMobileMenuTab)));
  searchButton?.addEventListener('click', () => {
    close();
    window.setTimeout(() => document.querySelector('#searchButton')?.click(), 0);
  });

  countryButton?.addEventListener('click', () => {
    close();
    window.setTimeout(() => document.querySelector('#locSelectorBtnMob')?.click(), 0);
  });

  languageButton?.addEventListener('click', () => {
    close();
    window.setTimeout(() => document.querySelector('#langSelectorOpenerDrawer')?.click(), 0);
  });

  menu.addEventListener('click', (event) => {
    if (event.target === menu) close(event);
  });

  document.addEventListener('keydown', (event) => {
    if (headerPanels) return;
    if (menu.getAttribute('aria-hidden') !== 'false') return;
    if (event.key === 'Escape') {
      close(event);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...menu.querySelectorAll('a[href], button:not([disabled])')].filter(element => element.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('resize', () => {
    if (!isMobile() && menu.getAttribute('aria-hidden') === 'false') {
      close();
      return;
    }
  });

  setTab(currentTabName());
})();
